module.exports = __webpack_public_path__ + "static/media/button-video-small-enabled.fbf5bbf1.svg";